

import React, { useContext, useState } from 'react'
import { GlobalContext } from '../GlobalContext'
import CloudformationOutputs from '../CloudformationOutputs.json'
import Modal from '../ui-elements/Modal'

type Props = {
    thisChecklistPeriod: ObjectStringKeyAnyValue
    thisChecklist: ObjectStringKeyAnyValue
    classString: string
    showCheckPeriodTimes?: boolean
    showCompletedCheck?: boolean
}


type AssetNameProps = {
    assetId: string
    assetName?: string
}

function AssetName({
    assetId,
    assetName
}: AssetNameProps) {

    if (assetName) {
        return <>"{assetName}" <span className={`text-xs font-sans italic text-gray-600`}>(#{assetId})</span></>
    } else {
        return <>asset Id #{assetId}</>
    }
}


function FormatChecklistTitle({
    thisChecklistPeriod,
    thisChecklist,
    classString,
    showCheckPeriodTimes = false,
    showCompletedCheck = false
}: Props) {

    const {
        tableData
    } = useContext(GlobalContext)

    const assetId = thisChecklistPeriod && thisChecklistPeriod.AssetId
    const assetName = assetId && tableData && tableData.Assets && tableData.Assets[assetId] && tableData.Assets[assetId].AssetName
    const checklistName = thisChecklist && thisChecklist['ChecklistName']
    const check_period_start = thisChecklistPeriod && thisChecklistPeriod['StartHoursMinsDay'] && thisChecklistPeriod['StartHoursMinsDay']['hours'] && thisChecklistPeriod['StartHoursMinsDay']['minutes'] ? `${String(thisChecklistPeriod['StartHoursMinsDay']['hours']).padStart(2, '0')}:${String(thisChecklistPeriod['StartHoursMinsDay']['minutes']).padStart(2, '0')}` : ''
    const check_period_end = thisChecklistPeriod && thisChecklistPeriod['EndHoursMins'] && thisChecklistPeriod['EndHoursMins']['hours'] && thisChecklistPeriod['EndHoursMins']['minutes'] ? `${String(thisChecklistPeriod['EndHoursMins']['hours']).padStart(2, '0')}:${String(thisChecklistPeriod['EndHoursMins']['minutes']).padStart(2, '0')}` : ''
    const checkPeriodsCombined = `(${check_period_start} - ${check_period_end})`
    const checkPeriodStartOnly = check_period_start ? `(${check_period_start})` : ''
    const checkPeriodStringToUse = check_period_start === check_period_end ? checkPeriodStartOnly : checkPeriodsCombined
    const checkPeriodTimeString = check_period_start && check_period_end ? ` ${checkPeriodStringToUse}` : ''

    const isComplete = thisChecklistPeriod && thisChecklistPeriod['Progress'] && thisChecklistPeriod['Progress']['progress_percentage'] && parseInt(`${thisChecklistPeriod['Progress']['progress_percentage']}`) === 100


    if (checklistName && assetId) {
        return <p className={classString}>
            {showCompletedCheck && isComplete ? <>✅ </> : ''}
            {checklistName} for <AssetName assetId={assetId} assetName={assetName} /> {showCheckPeriodTimes && checkPeriodTimeString}
        </p>
    }
    if (checklistName) {
        return <p className={classString}>
            {showCompletedCheck && isComplete ? <>✅ </> : ''}
            {checklistName} {showCheckPeriodTimes && checkPeriodTimeString}
        </p>
    }
    else {
        return <p className={classString}>
            {showCompletedCheck && isComplete ? <>✅ </> : ''} Checklist</p>
    }

}

export default FormatChecklistTitle